import { jwtDecode } from "jwt-decode";

interface Jwtpayload {
  // Flat top-level roles claim issued by the FastAPI auth service
  // (replaces Keycloak's nested realm_access.roles).
  roles: Array<string>;
}

export function getTokenClaims(token: string): Array<string> {
  const payload = jwtDecode<Jwtpayload>(token);
  return payload.roles ?? [];
}

export function checkUserHasRole(
  expectedRoles: Array<string>,
  actualRoles: Array<string>
): boolean {
  if (actualRoles.length === 0) {
    return false;
  }

  return expectedRoles.every((role: string) => actualRoles.includes(role));
}
